import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

import 'normalize.css/normalize.css'
import '@blueprintjs/core/dist/blueprint.css'
import './index.css'

export const API_BASE_URL = 'https://seafarer-api.abracontrols.com'

ReactDOM.render(<App />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js